export async function login({username, password}) {
    // return new Promise((resolve) =>
    //   setTimeout(() => resolve({ data: amount }), 500)
    // );
    //const url = 'https://reports.imon.gulfnet-cloud.com/v1/login';
    //const params = {loginName:username, password:password};
    //const query_params = new URLSearchParams(params); 
    ////const response = await fetch(url + '?' + query_params).then(res=>res.json()).catch(()=>null);
    //const res = await fetch(url + '?' + query_params);

    // const formData = new FormData();
    // formData.append('loginName', username);
    // formData.append('password', password);
    // const request = new Request('https://reports.imon.gulfnet-cloud.com/v1/login', {
    //   method: 'POST',
    //   body: formData,
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded'
    //   }
    // });
    const data = { loginName: username, password: password }
    // const request = new Request('https://reports.imon.gulfnet-cloud.com/v1/login', {
    //     method: 'POST',
    //     body: JSON.stringify(data),
    //     headers: {
    //       'Content-Type': "application/json; charset=utf-8"
    //     }
    // });
    // const res = await fetch(request);
    const res = await fetch('https://reports.imon.gulfnet-cloud.com/v1/login', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': "application/json; charset=utf-8"
      }
    });

    //return JSON.parse(await res.json());
    return res.json();
  }


//   export const login = (username, password) => async(dispatch, getState) => {
//     const state = getState()
//     const isLoggedIn = userSelectors.getIsLoggedIn(state);

//     if (!isLoggedIn) {
//         const url = 'url_to_login_api';
//         const params = {username:username, password:password};
//         const query_params = new URLSearchParams(params); 

//         const response = await fetch(url + '?' + query_params).then(res=>res.json()).catch(()=>null);
//         const name = response.username;
//         const uid = response.uid;
//         const token = response.token;
//         const isAdmin = response.isAdmin; // toBoolean?
//         dispatch(actions.login({uid:uid,name:name,token:token,isAdmin:isAdmin}));
//     }
    
// };
